import React, { useRef, useState } from 'react'
import { Dialog } from '@headlessui/react'

interface IProps {
    open: boolean
    onClose: () => void
    ariaLabel?: string
    className?: string
    children?: React.ReactNode
}

const DRAG_CLOSE_DISTANCE = 80

const BottomSheet: React.FC<IProps> = ({ open, onClose, ariaLabel, className, children }) => {
    const [dragOffset, setDragOffset] = useState(0)
    const dragStartRef = useRef<number | null>(null)

    const onPointerDown = (event: React.PointerEvent<HTMLDivElement>) => {
        dragStartRef.current = event.clientY
        event.currentTarget.setPointerCapture(event.pointerId)
    }

    const onPointerMove = (event: React.PointerEvent<HTMLDivElement>) => {
        if (dragStartRef.current === null) return
        setDragOffset(Math.max(0, event.clientY - dragStartRef.current))
    }

    const onPointerUp = () => {
        if (dragStartRef.current === null) return
        dragStartRef.current = null
        if (dragOffset > DRAG_CLOSE_DISTANCE) onClose()
        setDragOffset(0)
    }

    return (
        <Dialog open={open} onClose={onClose} className={'ui-sheet'}>
            <div className={'ui-sheet__backdrop'} aria-hidden />
            <Dialog.Panel
                aria-label={ariaLabel}
                className={`ui-sheet__panel ${className || ''}`}
                style={dragOffset > 0 ? { transform: `translateY(${dragOffset}px)` } : undefined}>
                <div
                    className={'ui-sheet__handle'}
                    onPointerDown={onPointerDown}
                    onPointerMove={onPointerMove}
                    onPointerUp={onPointerUp}
                    onPointerCancel={onPointerUp}>
                    <span />
                </div>
                {children}
            </Dialog.Panel>
        </Dialog>
    )
}

export default BottomSheet
